export const SAVE = 'step14.SAVE';
export const VALUE_CHANGED = 'step14.VALUE_CHANGED';
export const RESET = 'step14.RESET';
export const LOAD = 'step14.VALUE_LOAD';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step14/constants.js